import classes from './ShowcaseFooter.module.css';

const ShowcaseFooter: React.FC = () => {
  return <footer className={classes.footer}>© 2022 React e-commerce store by David Rizametov</footer>;
};

export default ShowcaseFooter;
